// extracted by mini-css-extract-plugin
export default {"MainCont":"MakeUp_MainCont__DfBYB","LeftCont":"MakeUp_LeftCont__LyKtN","RightCont":"MakeUp_RightCont__K+4OD"};